
import {
  computed, defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SelecionarNaturezaOperacao',
  components: {
  },
  props: {
    valor: {
      type: String,
      default: '1',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'change', 'blur'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:string) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:string) {
      emit('change', valor);
    }

    function blur() {
      emit('blur');
    }

    return {
      props,
      computedValor,
      blur,
      defineValorSelecionado,
      defineValorMarcado,
    };
  },
});
